import React, { useEffect } from "react";
import { messaging } from "@shared/services/firebase";
import { onMessage } from "firebase/messaging";
import AppRoutes from "@routes/Index";
import ToastNotification from "@shared/tostNotification/ToastNotification";
import { ThemeProvider } from "@context/ThemeContext";
import { SocketProvider } from "@context/SocketContext";
import { useDispatch, useSelector } from "react-redux";
import { loadBranding, BRAND } from "@shared/branding";
import { incomingNotification } from "@/store/slices/notification.actions";
import CallSocketManager from "@features/call/components/CallSocketManager";
import CallLiveKitManager from "@features/call/components/CallLiveKitManager";

const App: React.FC = () => {
  const dispatch = useDispatch();
  const tenantId = useSelector((s: any) => s.auth?.user?.tenantId || s.auth?.user?.tenant_id || null);
  const [, setBrandVersion] = React.useState(0);
  useEffect(() => {
    // Re-load branding for the logged-in user's agency.
    if (tenantId && tenantId !== BRAND.tenantId) {
      loadBranding(tenantId).then(() => setBrandVersion((v) => v + 1));
    }
  }, [tenantId]);
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload: any) => {
      dispatch(incomingNotification(payload));
    });

    return () => unsubscribe();
  }, [dispatch]);

  return (
    <>
      <ThemeProvider>
        <SocketProvider>
          <ToastNotification />
          <CallSocketManager />
          <CallLiveKitManager />
          <AppRoutes />
        </SocketProvider>
      </ThemeProvider>
    </>
  );
};

export default App;

